import { THIRTEEN_MONTHS_DAYS } from "@libertify.frontend/helpers";
import { createDismissedFlag } from "./createDismissedFlag";

// Exported so authService can tell LocalStorageTokenStore.clearAll() to
// preserve this prefix on logout — the nudge is meant to stay dismissed
// across logins, not just for the current session.
export const STORAGE_KEY_PREFIX = "mfa-setup-dismissed";

// Per-user flag so the "Enable 2FA?" nudge shows at most once per account,
// regardless of which button the user picked.
export const mfaSetupDismissed = createDismissedFlag(
  STORAGE_KEY_PREFIX,
  THIRTEEN_MONTHS_DAYS
);
